export const calculateKariyerPusulasi = (answers) => {
  const groups = { A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, H: 0, I: 0, 'İ': 0 };
  
  // Hangi sorunun hangi gruba ait olduğunun haritası
  const idToGroup = {
      1:'A', 2:'B', 3:'C', 4:'D', 5:'E', 6:'F', 7:'G', 8:'H', 9:'I', 10:'İ',
      11:'A', 12:'B', 13:'C', 14:'D', 15:'E', 16:'F', 17:'G', 18:'H', 19:'I', 20:'İ',
      21:'A', 22:'B', 23:'C', 24:'D', 25:'E', 26:'F', 27:'G', 28:'H', 29:'I', 30:'İ'
  };
  
  if (answers) {
    Object.keys(answers).forEach(qId => {
        const group = idToGroup[qId];
        if (group) {
            groups[group] += parseInt(answers[qId] || 0);
        }
    });
  }

  return {
      summary: "Kariyer Pusulası tamamlandı.",
      scores: groups,
      masterRisk: 'medium' // Risk gerektirmeyen bir test olduğu için standart değer
  };
};